import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ValidationErrorComponent } from './validation-error/validation-error.component';
import { MinDirective } from './min-validator.directive';
import { RequiredErrorComponent } from './required-error/required-error.component';
import { MaxDirective } from './max-validator.directive';
import { MaxErrorComponent } from './max-error/max-error.component';
import { MinErrorComponent } from './min-error/min-error.component';
import { MinlengthErrorComponent } from './minlength-error/minlength-error.component';
import { MaxlengthErrorComponent } from './maxlength-error/maxlength-error.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    ValidationErrorComponent,
    MinDirective,
    MaxDirective,
    RequiredErrorComponent,
    MaxErrorComponent,
    MinErrorComponent,
    MinlengthErrorComponent,
    MaxlengthErrorComponent
  ],
  exports: [
    ValidationErrorComponent,
    MinDirective,
    MaxDirective,
    RequiredErrorComponent,
    MaxErrorComponent,
    MinErrorComponent,
    MinlengthErrorComponent,
    MaxlengthErrorComponent
  ]
})
export class ValidationModule { }
